import React, { useEffect, useState, useCallback } from 'react'
import './Stake.css'
import { useAccount } from 'wagmi'
import { contractAddr1, contractAddr2, contractAddr3, tokenAdd, chainId } from '../../config'
import erc20Abi from '../../abi/erc20.json'
import stakeAbi from '../../abi/stake.json'
import Web3 from 'web3'
import moment from 'moment'
import Countdown from 'react-countdown'
import { prepareWriteContract, waitForTransaction, writeContract, readContract } from '@wagmi/core'
import { toast } from 'react-hot-toast'

const Stake = () => {
  const { address } = useAccount()
  const [spinner, setspinner] = useState(false)
  const [Stake_History_show, setStake_History_show] = useState([])
  const [totalEarned, setTotalEarned] = useState('0')
  const [principalReturned, setPrincipalReturned] = useState(false)

  let WebSupply = new Web3('https://polygon-rpc.com')

  const Stake_History = useCallback(async () => {
    try {
      if (!address) return

      const contractAddresses = [contractAddr1, contractAddr2, contractAddr3]
      let allStakes = []
      let totalEarnedValue = 0
      let anyPrincipalReturned = false

      for (let contractIndex = 0; contractIndex < contractAddresses.length; contractIndex++) {
        const contractAddress = contractAddresses[contractIndex]
        const stakingContract = new WebSupply.eth.Contract(stakeAbi, contractAddress)

        const userStakes = await stakingContract.methods.getUserStakes(address).call()
        const principalReturnedStatus = await stakingContract.methods.principalReturnAtEnd().call()
        if (principalReturnedStatus) anyPrincipalReturned = true

        const earned = await stakingContract.methods.pendingRewards(address).call()
        totalEarnedValue += parseFloat(WebSupply.utils.fromWei(earned.toString())) * 1e12

        for (let i = 0; i < userStakes.length; i++) {
          const stake = userStakes[i]
          const amount = (
            parseFloat(WebSupply.utils.fromWei(stake.amount.toString())) * 1e12
          ).toFixed(2)
          const unlockTime = Number(stake.unlockTime)
          const date = moment(unlockTime * 1000).format('DD-MM-YYYY')

          allStakes.push({
            Sno: allStakes.length + 1,
            amount,
            address,
            unLoackTime: unlockTime,
            LockTime: date,
            contractAddress,
            index: i,
          })
        }
      }

      setPrincipalReturned(anyPrincipalReturned)
      setTotalEarned(totalEarnedValue.toFixed(2))
      setStake_History_show(allStakes)
    } catch (error) {
      console.log(error)
    }
  }, [address])

  useEffect(() => {
    Stake_History()
    const interval = setInterval(() => {
      Stake_History()
    }, 10000)
    return () => clearInterval(interval)
  }, [address, Stake_History])

  const Completionist = () => {
    return <div className="text_days fs-5 ">Unstaked Time Reached!</div>
  }

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <Completionist />
    } else {
      return (
        <div className="text_days fs-5 ">
          {days}d : {hours}h : {minutes}m : {seconds}s
        </div>
      )
    }
  }

  const Withdraw = async (index, contractAddress) => {
    try {
      setspinner(true)
      const { request } = await prepareWriteContract({
        address: contractAddress,
        abi: stakeAbi,
        args: [index],
        functionName: 'unstake',
        account: address,
      })
      const { hash } = await writeContract(request)
      await waitForTransaction({ hash })

      toast.success('Transaction Completed')
      setspinner(false)
      Stake_History()
    } catch (error) {
      console.log(error)
      toast.error('Transaction Failed')
      setspinner(false)
    }
  }

  const ClaimReward = async () => {
    try {
      setspinner(true)
      const contractAddresses = [contractAddr1, contractAddr2, contractAddr3]
      let claimedAny = false

      for (let i = 0; i < contractAddresses.length; i++) {
        const contractAddress = contractAddresses[i]
        const rewards = await readContract({
          address: contractAddress,
          abi: stakeAbi,
          functionName: 'pendingRewards',
          args: [address],
        })

        const rewardsValue = parseFloat(WebSupply.utils.fromWei(rewards.toString()))
        if (rewardsValue > 0) {
          try {
            const { request } = await prepareWriteContract({
              address: contractAddress,
              abi: stakeAbi,
              functionName: 'claimRewards',
              account: address,
            })
            const { hash } = await writeContract(request)
            await waitForTransaction({ hash })
            claimedAny = true
          } catch (err) {
            console.warn(`Failed to claim rewards from ${contractAddress}`, err)
          }
        } else {
          console.log(`No rewards to claim from ${contractAddress}`)
        }
      }

      if (claimedAny) {
        toast.success('Reward Claimed!')
      } else {
        toast('No rewards available to claim', { icon: 'ℹ️' })
      }
    } catch (error) {
      console.error(error)
      toast.error('Transaction Failed')
    } finally {
      setspinner(false)
      Stake_History()
    }
  }

  const current_Time = Math.floor(new Date().getTime() / 1000.0)

  return (
    <div
      className="container font-website mx-auto lg:px-10 px-5 py-5"
      style={{ borderBottom: '2px solid white' }}
    >
      <div className="flex flex-col items-center justify-center lg:py-0 py-8">
        <div className="text-center">
          <p className="text-center pb-1 text-3xl font-bold site-font text-white">Your Minings</p>
          <hr className="line flex mx-auto mb-8" />
        </div>
        <div className="d-flex justify-content-between align-items-center mb-4 w-100">
          <div className="site-font text-white fs-5">
            Total Earned: <strong>{totalEarned}</strong> USDT
          </div>
          <button className="claim-button" onClick={ClaimReward}>
            {spinner ? 'Claiming...' : 'Claim'}
          </button>
        </div>
        <div className="MuiBox-root css-ihc79b">
          <div className="d-flex justify-content-end align-items-center mb-3">
            <button className="button-5" tabIndex={0} type="button" onClick={Stake_History}>
              <span className="me-2 site-font text-white">Refresh</span>
              <span role="img" aria-label="sync" className="anticon anticon-sync SyncOutlined">
                <svg
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="sync"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 01755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 01512.1 856a342.24 342.24 0 01-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 00-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 00-8-8.2z" />
                </svg>
              </span>
            </button>
          </div>
          <div className="  css-48ybtg" border="none" pt={2} pb={5}>
            <table
              className="MuiTable-root css-1owb465"
              aria-label="simple table"
              style={{ minWidth: 600 }}
            >
              <thead className="MuiTableHead-root css-1wbz3t9 site-font">
                <tr className="text-white  css-1gqug66 site-font">
                  <th
                    className=" text-white css-1gzy9y4"
                    scope="col"
                    style={{ fontSize: 16, color: '#00000' }}
                  >
                    No.
                  </th>
                  <th
                    className="site-font text-white   css-1gzy9y4"
                    scope="col"
                    style={{ fontSize: 16, color: 'rgb(255, 255, 255)' }}
                  >
                    Mining Amount
                  </th>
                  <th
                    className="site-font text-white   css-1gzy9y4"
                    scope="col"
                    style={{ fontSize: 16, color: 'rgb(255, 255, 255)' }}
                  >
                    Remaining Time
                  </th>
                  <th
                    className="site-font text-white   css-1gzy9y4"
                    scope="col"
                    style={{ fontSize: 16, color: 'rgb(255, 255, 255)' }}
                  >
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="MuiTableBody-root css-1xnox0e">
                {Stake_History_show.length === 0 ? (
                  <tr>
                    <td className=" site-font  css-q34dxg" colSpan={5} style={{ border: 'none' }}>
                      <div className="MuiBox-root css-ehd0rl">
                        <p className=" site-font text-white MuiTypography-root MuiTypography-body1 css-o7q7an">
                          You have no mining data
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  Stake_History_show.map((item, idx) => {
                    if (item.unstaked === true || item.withdrawan === true) return null
                    return (
                      <tr className=" css-1gqug66" key={`${item.contractAddress}-${item.index}`}>
                        <td className="site-font text-white css-q34dxg text-white text-center">
                          {item.Sno}
                        </td>
                        <td className="site-font text-white css-q34dxg text-white text-center">
                          {item.amount}
                        </td>
                        <td className="site-font text-white css-q34dxg text-white text-center">
                          <Countdown date={item.unLoackTime * 1000} renderer={renderer} />
                        </td>
                        <td className="css-q34dxg text-white text-center">
                          <button
                            className="button-5"
                            tabIndex={0}
                            type="button"
                            disabled={
                              current_Time < item.unLoackTime || !principalReturned || spinner
                            }
                            onClick={() => {
                              if (current_Time < item.unLoackTime) {
                                toast.error('Unstake time not reached!')
                                return
                              }
                              if (!principalReturned) {
                                toast.error('Principal not yet returned.')
                                return
                              }
                              Withdraw(item.index, item.contractAddress)
                            }}
                          >
                            {current_Time < item.unLoackTime
                              ? 'Locked'
                              : !principalReturned
                              ? 'Principal not available'
                              : spinner
                              ? 'Unstaking...'
                              : 'Unstake'}
                          </button>
                        </td>
                      </tr>
                    )
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Stake
